import React from "react";
import { DatePicker, Form, Input, Modal, Select, type FormInstance } from "antd";

import { SalesMeetingStatus } from "@fitness-app/data-models/entities/SalesMeeting";

import { meetingStatusLabels } from "../salesCrmConstants";
import { type ManualMeetingForm } from "../salesCrmTypes";

type SellerOption = { value: string; label: string };

type AddMeetingModalProps = {
  open: boolean;
  form: FormInstance<ManualMeetingForm>;
  confirmLoading: boolean;
  sellerSelectionLocked: boolean;
  sellerOptions: SellerOption[];
  onCancel: () => void;
  onFinish: (values: ManualMeetingForm) => void;
};

export const AddMeetingModal = ({
  open,
  form,
  confirmLoading,
  sellerSelectionLocked,
  sellerOptions,
  onCancel,
  onFinish,
}: AddMeetingModalProps): React.ReactElement => (
  <Modal
    title="Dodaj spotkanie ręcznie"
    open={open}
    onCancel={onCancel}
    onOk={() => form.submit()}
    okText="Dodaj spotkanie"
    confirmLoading={confirmLoading}
  >
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Form.Item name="teamMemberId" label="Sprzedawca" rules={[{ required: true, message: "Wybierz sprzedawcę" }]}>
        <Select
          showSearch
          optionFilterProp="label"
          disabled={sellerSelectionLocked}
          options={sellerOptions}
          placeholder="Wybierz sprzedawcę"
        />
      </Form.Item>
      <div className="grid grid-cols-1 gap-x-4 md:grid-cols-2">
        <Form.Item
          name="clientEmail"
          label="Email klienta"
          rules={[
            { required: true, message: "Podaj email klienta" },
            {
              type: "email",
              message: "Podaj poprawny email",
              transform: (value: string) => value?.trim(),
            },
          ]}
        >
          <Input placeholder="klientka@example.com" />
        </Form.Item>
        <Form.Item name="clientName" label="Imię i nazwisko klienta">
          <Input />
        </Form.Item>
        <Form.Item
          name="startTime"
          label="Data i godzina rozmowy"
          rules={[{ required: true, message: "Podaj datę rozmowy" }]}
        >
          <DatePicker showTime={{ format: "HH:mm" }} format="DD.MM.YYYY HH:mm" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item name="status" label="Status spotkania" rules={[{ required: true }]}>
          <Select
            options={Object.values(SalesMeetingStatus).map((value) => ({
              value,
              label: meetingStatusLabels[value],
            }))}
          />
        </Form.Item>
      </div>
      <Form.Item name="notes" label="Notatka">
        <Input.TextArea rows={3} />
      </Form.Item>
    </Form>
  </Modal>
);
